// Root classname

export var ROOT = 'inline-flex h-56';
export var SM_ROOT = 'inline-flex h-32';

// Wrapper classnames

export var BASE_WRAPPER = 'inline-flex w-full z-1';
export var WRAPPER_DEFAULT = function WRAPPER_DEFAULT(dark) {
  return "".concat(BASE_WRAPPER, " cursor-pointer").concat(!dark ? ' border border-solid border-gray-main' : '');
};
export var WRAPPER_CHECK = function WRAPPER_CHECK(dark) {
  return "".concat(BASE_WRAPPER, " cursor-pointer").concat(!dark ? ' border border-solid border-green-main' : '');
};
export var WRAPPER_OPEN = function WRAPPER_OPEN(dark) {
  return "".concat(BASE_WRAPPER, " z-4 cursor-pointer").concat(!dark ? ' shadow-dropdown' : '');
};
export var WRAPPER_DISABLED = function WRAPPER_DISABLED() {
  return "".concat(BASE_WRAPPER, " cursor-default");
};
export var WRAPPER = {
  "default": WRAPPER_DEFAULT,
  open: WRAPPER_OPEN,
  disabled: WRAPPER_DISABLED,
  check: WRAPPER_CHECK,
  sm: WRAPPER_DEFAULT
};

// Main box classnames

export var BASE_BOX = 'inline-flex flex-shrink-0 justify-between items-center w-full h-56 px-16';
export var SM_BOX = 'inline-flex flex-shrink-0 justify-between items-center w-full h-32 px-16';
export var MAIN_BOX_DEFAULT = function MAIN_BOX_DEFAULT(dark) {
  return "".concat(BASE_BOX, " relative ").concat(dark ? 'bg-base-lighter-16 text-base-lighter' : 'bg-white text-base-main');
};
export var MAIN_BOX_DISABLED = function MAIN_BOX_DISABLED(dark) {
  return "".concat(BASE_BOX, " relative ").concat(dark ? 'bg-gray-dark-16 text-gray-dark' : 'bg-gray-lighter text-base-lighter');
};
export var SECONDARY_BOX_SM = function SECONDARY_BOX_SM(dark) {
  return "".concat(SM_BOX, " relative ").concat(dark ? 'bg-base-lighter-24 text-base-lighter' : 'bg-white text-base-main');
};
export var MAIN_BOX = {
  "default": MAIN_BOX_DEFAULT,
  open: MAIN_BOX_DEFAULT,
  disabled: MAIN_BOX_DISABLED,
  sm: SECONDARY_BOX_SM
};

// Option classnames

export var OPTION_WRAPPER = 'inline-flex flex-col h-full w-full overflow-auto crehui-scrollable';
export var OPTION = /*#__PURE__*/"".concat(BASE_BOX, " text-base-main bg-white hover:text-primary-main hover:bg-gray-lighter");
export var ERROR_TEXT = 'absolute left-0 bottom-0 font-nun text-11 leading-12 tracking-1 text-red-main';